<template>
  <span v-if="levelNumber !== null" class="live-level-badge" :class="{ compact }" :title="title || `StarLive Lv.${levelNumber}`">
    <img v-if="resolvedIcon && !iconFailed" :src="resolvedIcon" :alt="$t('levelUi.levelIconAlt', { level: levelNumber })" @error="iconFailed = true">
    <b>Lv.{{ $n(levelNumber) }}</b>
  </span>
</template>

<script>
import { platformAssetUrl } from "../utils/media"

export default {
  name: "LiveLevelBadge",
  props: {
    level: { type: [Number, String], default: null },
    iconUrl: { type: String, default: "" },
    title: { type: String, default: "" },
    compact: { type: Boolean, default: false }
  },
  data() {
    return { iconFailed: false }
  },
  computed: {
    levelNumber() {
      if (this.level === null || this.level === undefined || this.level === "") return null
      return Math.max(0, Number(this.level) || 0)
    },
    resolvedIcon() {
      return platformAssetUrl(this.iconUrl)
    }
  },
  watch: {
    iconUrl() {
      this.iconFailed = false
    }
  }
}
</script>

<style scoped>
.live-level-badge{min-width:0;display:inline-flex;align-items:center;gap:3px;flex:none;padding:2px 5px 2px 3px;border:1px solid rgba(255,194,95,.3);border-radius:999px;color:#ffe0a1;background:linear-gradient(105deg,rgba(91,57,22,.78),rgba(35,28,26,.72));box-shadow:0 4px 12px rgba(0,0,0,.16);vertical-align:middle;white-space:nowrap}.live-level-badge img{width:17px;height:17px;display:block;flex:none;object-fit:contain}.live-level-badge b{font-size:8px;line-height:1;font-weight:900}.live-level-badge.compact{gap:2px;padding:1px 4px 1px 2px}.live-level-badge.compact img{width:14px;height:14px}.live-level-badge.compact b{font-size:7px}@media(prefers-reduced-motion:reduce){.live-level-badge{transition:none}}
</style>
